import { render } from "./ProfitLossAnalytics.vue?vue&type=template&id=10bbc5e6&scoped=true"
import script from "./ProfitLossAnalytics.vue?vue&type=script&lang=js"
export * from "./ProfitLossAnalytics.vue?vue&type=script&lang=js"

import "./ProfitLossAnalytics.vue?vue&type=style&index=0&id=10bbc5e6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bbc5e6"]])

export default __exports__